export const FilterKeys = {
    allClubs: 'allClubsV2',
    pendingClubs: 'pendingClubsV1',
    allTeamPlayers: 'allTeamPlayers',
    allCompetitions: 'allCompetitions',
    newPlayersBase: 'newPlayersBase',
    renewDlPlayers: 'renewDlPlayers',
    allTeams: 'allTeams',
    availableTeamPlayers: 'availableTeamPlayersV8',
    allNotifications: 'allNotifications',
    freePlayersBase: 'freePlayersBase',
    compensationCandidates: 'compensationCandidatesV1',
    allPlayersBase: 'allPlayersBase',
    allPlayersExport: 'allPlayersExportV1',
    renewOtherPlayersBase: 'renewOtherPlayersBase',
    activePlayersBase: 'activePlayersBaseV2',
    allTeamsTable: 'allTeamsTable',
    inactivePlayersTable: 'inactivePlayersTable',
    newPlayersTable: 'newPlayersTable',
    allGamesTable: 'allGamesTableV8',
    gameJerseyTable: 'gameJerseyTableV2',
    allUsers: 'allUsers',
    allSeasons: 'allSeasons',
    allPersonnelTypes: 'allPersonnelTypes',
    allPersonnel: 'allPersonnel',
    allSportHalls: 'allSportHalls',
    allReferees: 'allReferees',
    competitionParts: 'competitionParts',
    pendingInfoTeamsTable: 'pendingInfoTeamsTable',
    gamesRescheduleTable: 'gamesRescheduleTable',
    seasonCalendar: 'seasonCalendarV3',
    oksAllResultsTable: 'oksAllResultsTableV4',
    teamRankTable: 'teamRankTableV8',
};
